import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../../constants/main';
import { TrimSelectStyledAC } from './AC/TrimSelectStyled.AC';
import { TrimSelectStyledAP } from './AP/TrimSelectStyled.AP';
import { TrimSelectStyledDS } from './DS/TrimSelectStyled.DS';
import { TrimSelectStyledOV } from './OV/TrimSelectStyled.OV';
import { TrimSelectStyledOVGB } from './OV/GB/TrimSelectStyled.OV.GB';
import { TrimSelectStyled } from './TrimSelectStyled';
import { SC } from '../../../styles/theme';

export type TrimSelectProps = SC & {
    onTrimSelectClick?: (label?: string) => void;
    onTrimFeaturesClick?: (label?: string) => void;
};

const TrimSelect = (props: TrimSelectProps) => {
    if (isBrandOV) return isMarketGB ? <TrimSelectStyledOVGB {...props} /> : <TrimSelectStyledOV {...props} />;
    if (BRAND === 'AC') return <TrimSelectStyledAC {...props} />;
    if (BRAND === 'AP') return <TrimSelectStyledAP {...props} />;
    if (BRAND === 'DS') return <TrimSelectStyledDS {...props} />;
    return <TrimSelectStyled {...props} />;
};

export default TrimSelect;
